__turbopack_context__.v({
  "footer": "b2b-inquiry-module-scss-module__YgXKzW__footer",
  "info": "b2b-inquiry-module-scss-module__YgXKzW__info",
  "info-icon": "b2b-inquiry-module-scss-module__YgXKzW__info-icon",
  "info-rules": "b2b-inquiry-module-scss-module__YgXKzW__info-rules",
  "input": "b2b-inquiry-module-scss-module__YgXKzW__input",
  "title": "b2b-inquiry-module-scss-module__YgXKzW__title",
});
